import _ from 'lodash'
import { useFormContext } from 'react-hook-form'

import { sanitizeEmbedHtml } from '@/shared/lib/html/sanitize'

export const LevelPlayIframe = ({ activity }) => {
  const { meta } = activity
  const iframe = _.get(meta, 'iframe')

  return (
    <div
      className="w-full min-h-full [&_iframe]:w-full [&_iframe]:h-full [&_iframe]:min-h-[400px] [&_iframe]:border-0"
      dangerouslySetInnerHTML={{ __html: sanitizeEmbedHtml(iframe) }}
    />
  )
}
